"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, switchMap, catchError, map, mergeAll } from "rxjs/operators";

import { requestTypes } from "../_constants";
import { lcvManualPrizeWinsConstants } from "../_constants/lcvManualPrizeWins.constants";
import {
     lcvManualPrizeWinsGetRequest,
     lcvManualPrizeWinsGetComplete,
     lcvManualPrizeWinsSetFulfilmentComplete,
} from "../_actions/lcvManualPrizeWins.action";
import { ajaxError } from "../_actions";
import { getRequestHeader } from "../../_helpers/request.header";
import { withLcvCampaign } from "./lcvCampaign.epic";

export const lcvManualPrizeWinsGetEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_GET_REQUEST),
          switchMap((incoming) =>
               ajax
                    .post("/api/lcvManualPrizeWins/getWins", withLcvCampaign(incoming.payload, state$), getRequestHeader(requestTypes.REQUEST_TYPE_POST))
                    .pipe(
                         map((ajaxResponse) => lcvManualPrizeWinsGetComplete(ajaxResponse.response)),
                         catchError((error) => of(ajaxError(error))),
                    ),
          ),
     );
};

// Marking a prize as sent answers with a message and no data, so the list is read back rather than
// patched from the response. The page being viewed rides along on the write, so the reload lands on
// the same page the person is looking at rather than sending them back to the first one.
export const lcvManualPrizeWinsSetFulfilmentEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_REQUEST),
          mergeMap((incoming) =>
               ajax
                    .post("/api/lcvManualPrizeWins/setFulfilment", withLcvCampaign(incoming.payload, state$), getRequestHeader(requestTypes.REQUEST_TYPE_POST))
                    .pipe(
                         map((ajaxResponse) =>
                              of(
                                   lcvManualPrizeWinsSetFulfilmentComplete(ajaxResponse.response),
                                   lcvManualPrizeWinsGetRequest(incoming.payload.listQuery || {}),
                              ),
                         ),
                         catchError((error) => of(of(ajaxError(error)))),
                         mergeAll(),
                    ),
          ),
     );
};
